import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    message: String
  }
  static targets = ["tooltip"]

  connect() {
    // Create tooltip element if it doesn't exist
    if (!this.hasTooltipTarget) {
      this.createTooltip()
    }
  }

  createTooltip() {
    const tooltip = document.createElement("div")
    tooltip.dataset.hoverMessageTarget = "tooltip"
    tooltip.className = "hover-message-tooltip"
    tooltip.textContent = this.messageValue
    tooltip.style.display = "none"
    this.element.appendChild(tooltip)
  }

  show() {
    if (this.hasTooltipTarget) {
      this.tooltipTarget.style.display = "block"
    }
  }

  hide() {
    if (this.hasTooltipTarget) {
      this.tooltipTarget.style.display = "none"
    }
  }
}
